"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_DeviceDefinition_DeviceName = exports.DeviceDefinition_DeviceNameTypeKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Element_1 = require("./RTTI_Element");
var DeviceDefinition_DeviceNameTypeKind;
(function (DeviceDefinition_DeviceNameTypeKind) {
    DeviceDefinition_DeviceNameTypeKind["_udiLabelName"] = "udi-label-name";
    DeviceDefinition_DeviceNameTypeKind["_userFriendlyName"] = "user-friendly-name";
    DeviceDefinition_DeviceNameTypeKind["_patientReportedName"] = "patient-reported-name";
    DeviceDefinition_DeviceNameTypeKind["_manufacturerName"] = "manufacturer-name";
    DeviceDefinition_DeviceNameTypeKind["_modelName"] = "model-name";
    DeviceDefinition_DeviceNameTypeKind["_other"] = "other";
})(DeviceDefinition_DeviceNameTypeKind = exports.DeviceDefinition_DeviceNameTypeKind || (exports.DeviceDefinition_DeviceNameTypeKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_DeviceDefinition_DeviceName = t.recursion('IDeviceDefinition_DeviceName', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        name: t.string,
        _name: RTTI_Element_1.RTTI_Element,
        type: (0, EnumType_1.createEnumType)(DeviceDefinition_DeviceNameTypeKind, 'DeviceDefinition_DeviceNameTypeKind'),
        _type: RTTI_Element_1.RTTI_Element
    });
});
//# sourceMappingURL=RTTI_DeviceDefinition_DeviceName.js.map